// export function authHeader() {
//   const token = sessionStorage.getItem("token");
//   if (token) {
//     return { Authorization: "Bearer " + token };
//   } else {
//     return {};
//   }
// }

// export function getToken() {
//   const token = sessionStorage.getItem("token");
//   if (token) {
//     return { token };
//   } else {
//     return null;
//   }
// }

// export function getRegToken() {
//   const token = sessionStorage.getItem("reg");
//   if (token) {
//     return { token };
//   } else {
//     return null;
//   }
// }

// export const formatAsMoney = (amount) => {
//   const locale = JSON.parse(localStorage.getItem("locale"));
//   const { country_code, currency_code: currency } = locale;
//   return new Intl.NumberFormat(`en-${country_code}`, {
//     style: "currency",
//     currency,
//   }).format(amount);
// };

// export const isFloat = (value) => {
//   if (!isNaN(Number(value)) && value.toString().indexOf('.') != -1){
//     return true
//   }
//   return false
// }

// export const Capitaliza = (value) => {
//   const firstChar = value?.charAt(0)?.toUpperCase();
//   const remainingChars = value.slice(1);
//   return `${firstChar}${remainingChars}`;
// }

// export const getTruthyCount = (length, filters) => {
//   let count = 0;
//   Object.values(filters).map((filter) => {
//     filter !== undefined && count++;
//   });
//   if (length && count > length) {
//     return true;
//   } else if (length && count < length) {
//     return false;
//   }
//   if (count > 2) {
//     return true;
//   }
//   return false;
// };

const isBrowser = typeof window !== "undefined";

// console.log("isBrowser:", isBrowser);

export function authHeader() {
  if (!isBrowser) return {};

  const token = sessionStorage.getItem("token");
  if (token) {
    return { Authorization: "Bearer " + token };
  } else {
    return {};
  }
}

export function getToken() {
  if (!isBrowser) return null;

  const token = sessionStorage.getItem("token");
  if (token) {
    return { token };
  } else {
    return null;
  }
}

export function getRegToken() {
  if (!isBrowser) return null;

  const token = sessionStorage.getItem("reg");
  if (token) {
    return { token };
  } else {
    return null;
  }
}

export const formatAsMoney = (amount) => {
  if (!isBrowser) return amount;

  const localeRaw = localStorage.getItem("locale");
  if (!localeRaw) return amount;

  const locale = JSON.parse(localeRaw);
  const { country_code, currency_code: currency } = locale;

  return new Intl.NumberFormat(`en-${country_code}`, {
    style: "currency",
    currency,
  }).format(amount);
};

export const isFloat = (value) => {
  if (!isNaN(Number(value)) && value.toString().indexOf('.') !== -1) {
    return true;
  }
  return false;
};

export const Capitaliza = (value = "") => {
  const firstChar = value?.charAt(0)?.toUpperCase();
  const remainingChars = value.slice(1);
  return `${firstChar}${remainingChars}`;
};

export const getTruthyCount = (length, filters) => {
  let count = 0;
  Object.values(filters).forEach((filter) => {
    filter !== undefined && count++;
  });

  if (length && count > length) return true;
  if (length && count < length) return false;

  if (count > 2) return true;
  return false;
};


export const config = {
  bucketName: "com.idonatio.web",
  dirName: "media" /* optional */,
  region: "eu-west-2",
  // accessKeyId: 'JAJHAFJFHJDFJSDHFSDHFJKDSF',
  secretAccessKey: "2a70914d-58b1-4399-84d4-8cd2c16968c8",
  // s3Url: 'https:/your-custom-s3-url.com/', /* optional */
};
